import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * 台帳横断の調達情報 API。
 * ledger: 'eng' | 'eng_equipment' | 'it' | 'office'
 */
export const assetProcurementApi = {
  purchaseSummary: (ledger, id) =>
    axios.get(`${API}/asset-procurement/${ledger}/${id}/purchase-summary`).then((r) => r.data),
  saveSerials: (entries) =>
    axios.post(`${API}/asset-procurement/serials`, { entries }).then((r) => r.data),
  suppliers: () => axios.get(`${API}/mfg/suppliers`).then((r) => r.data),
  createSupplier: (body) => axios.post(`${API}/mfg/suppliers`, body).then((r) => r.data),
};

export const LEDGER_LABEL = {
  eng: '技術資産',
  eng_equipment: '設備台帳',
  it: 'IT資産',
  office: '備品',
};

// 「この資産を発注」— 部品受注入力の新規依頼へ渡す1行分のプレフィル。
// URL に品名や単価を載せない（共有されたリンクから社内の価格が漏れる）。
const PREFILL_KEY = 'sensbey.orderPrefill';

export const stashOrderPrefill = (payload) => {
  try {
    sessionStorage.setItem(PREFILL_KEY, JSON.stringify({ ...payload, at: Date.now() }));
    return true;
  } catch {
    return false;
  }
};

// 読むだけ（消さない）。画面が一度作り直されると消費済みになって
// 1行目が空のまま開いてしまうため、消すのは実際に使えたあと（clearOrderPrefill）。
export const peekOrderPrefill = () => {
  try {
    const raw = sessionStorage.getItem(PREFILL_KEY);
    if (!raw) return null;
    const v = JSON.parse(raw);
    // 10分以上前のものは使わない（別の作業に紛れ込ませない）
    if (!v?.at || Date.now() - v.at > 10 * 60 * 1000) {
      sessionStorage.removeItem(PREFILL_KEY);
      return null;
    }
    return v;
  } catch {
    return null;
  }
};

export const clearOrderPrefill = () => {
  try { sessionStorage.removeItem(PREFILL_KEY); } catch { /* noop */ }
};

export const takeOrderPrefill = () => {
  const v = peekOrderPrefill();
  if (v) clearOrderPrefill();
  return v;
};
